import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'web-ui-components/lib/atoms/buttons';
import { ButtonGroup } from 'web-ui-components/lib/molecules/buttons';

const PageNavigation = ({
	handleContinue,
	handleBack,
	showContinue,
	showBack,
	enableContinue,
	enableBack,
	continueButtonText,
	secondaryButtonText,
	showLoading,
	children,
}) => (
	<div className="u-margin-top-2" data-cy="servicing-section">
		<ButtonGroup>
			{children}
			{showBack && (
				<Button
					id="button-back"
					display="secondary"
					className="u-margin-right-1"
					onClick={handleBack}
					disabled={!enableBack}
					data-cy="button-back"
				>
					{secondaryButtonText}
				</Button>
			)}
			{showContinue && (
				<Button
					isLoading={showLoading}
					id="button-continue"
					display="primary"
					onClick={handleContinue}
					disabled={!enableContinue}
					data-cy="button-continue"
				>
					{continueButtonText}
				</Button>
			)}
		</ButtonGroup>
	</div>
);

PageNavigation.propTypes = {
	handleContinue: PropTypes.func,
	handleBack: PropTypes.func,
	showContinue: PropTypes.bool,
	showBack: PropTypes.bool,
	enableContinue: PropTypes.bool,
	enableBack: PropTypes.bool,
	continueButtonText: PropTypes.string,
	secondaryButtonText: PropTypes.string,
	showLoading: PropTypes.bool,
	children: PropTypes.node,
};

PageNavigation.defaultProps = {
	continueButtonText: 'Continue',
	secondaryButtonText: 'Back',
};

export default PageNavigation;
